import React from "react"
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { normalizeLang } from '../../utils/localeDataLoader';
import { getNavMenuByLanguage } from '../../apis/navMenus';

function PageNotFound() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const goHome = async () => {
    const lang = normalizeLang(i18n.language);
    try {
      const data = await getNavMenuByLanguage(lang);
      const homeItem = data.find(item => item.keyName === 'menu.home');
      navigate(homeItem ? `/${homeItem.slug}` : '/');
    } catch {
      navigate('/');
    }
  };

  return (
    <div className="PageNotFound">
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="main">
        <h1>{t('notfound.title')}</h1>
        <p dangerouslySetInnerHTML={{ __html: t('notfound.message') }}></p>
        <button type="button" onClick={goHome}>{t('notfound.button')}</button>
      </div>
    </div>
  )
}

export default PageNotFound